import React, { useEffect, useState } from 'react'

export const SvgSprite: React.FC = () => {
  const [spriteContent, setSpriteContent] = useState<string>('')

  useEffect(() => {
    if (typeof document !== 'undefined' && document.getElementById('svg-sprite-container')) {
      return
    }

    fetch('/icon_sprite.svg')
      .then((response) => response.text())
      .then((svg) => {
        setSpriteContent(svg)
      })
      .catch((error) => {
        console.warn('Failed to load SVG sprite:', error)
      })
  }, [])

  if (!spriteContent) return null

  return (
    <div id="svg-sprite-container" style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: spriteContent }} />
  )
}
